<template>
  <div>
    <ValidationProvider
      v-if="hasValidator"
      :name="$attrs.label"
      :rules="rules"
      v-slot="{ errors, valid }">
        <b-field
          v-bind="$attrs"
          :type="{ 'is-danger': errors[0]}"
          :message="errors">
            <b-taginput
                v-model="selected"
                :data="filterLocations"
                autocomplete
                :open-on-focus="true"
                field="name"
                type="is-primary"
                :maxtags="1"
                :has-counter="false"
                icon="label"
                placeholder="Selecciona una ubicación"
                @typing="text = $event" :loading="isLoading">
                <template slot-scope="props">{{props.option.name}}</template>
            </b-taginput>
        </b-field>
    </ValidationProvider>
    <b-taginput
      v-else
      v-model="selected"
      :data="filterLocations"
      autocomplete
      :open-on-focus="true"
      field="name"
      type="is-primary"
      :maxtags="1"
      :has-counter="false"
      icon="label"
      placeholder="Selecciona una ubicación"
      @typing="text = $event" :loading="isLoading">
        <template slot-scope="props">{{props.option.name}}</template>
    </b-taginput>
  </div>
</template>

<script>
import LocationService from '@/services/LocationService'

export default {
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    hasValidator: {
      type: Boolean,
      default: false
    },
    value: {
      required: false,
      default: null
    }
  },
  created () {
    this.getLocations()
  },
  data () {
    return {
      text: '',
      selected: null,
      locations: [],
      isLoading: false
    }
  },
  methods: {
    async getLocations () {
      this.isLoading = true
      let response = await LocationService.getLocations()
      this.locations = response.data.data
      if (this.value) {
        this.selected = this.locations.filter((x) => x.name === this.value)
      }
      this.isLoading = false
    }
  },
  computed: {
    filterLocations () {
      return this.locations.filter((location) => {
        return `${location.name}`
          .toString()
          .toLowerCase()
          .indexOf(this.text.toLowerCase()) >= 0
      })
    }
  },
  watch: {
    selected () {
      this.$emit('select', this.selected[0])
    },
    value (value) {
      if (value) {
        this.selected = this.locations.filter((x) => x.name === this.value)
      }
    }
  }

}
</script>
